import React from 'react';
import cs from 'classnames';
import {push as changeURL} from 'react-router-redux';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import trim from 'lodash/trim';
import isEmpty from 'lodash/isEmpty';

import store from '~/store';
import Button from '~/components/common/Button';
import PerchaseTerms from '~/components/pages/PaymentProcess/PerchaseTerms';
import {errorInfoConfig} from '~/misc/error-info';
import LoadingSpiner from '~/components/pages/MyAccount/share/LoadingSpiner';
import {centTo$} from '~/misc/formatMoney';
import {getUrlQeury} from '~/misc/formatUrlquery';
import {getDirectOrderInfo, createOrderActions} from '~/modules/customerServicePaymentProcess/actions';
import Spinner from '~/components/common/Spinner';
// import vipShownameTransfer from '~/components/pages/vipShownameTransfer.js';

import CreateAccountCss from '../index.css';
import css from '~/components/pages/PaymentProcess/Payment/index.css';
import sharedCss from '~/components/pages/PaymentProcess/index.css';
import appCss from '~/components/shared.css';


class CreatePayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      haveReadPerchaseTerms: false,
      readPerchaseError: '',
      haveReadPaymentInfo: false,
      readPaymentError: '',
      signature: '',
      signatureError: '',
      ID: '',
      queryFirstName: '',
      queryLastName: '',
    };
    this.changeReadPerchaseValue = this.changeReadPerchaseValue.bind(this);
    this.changeReadPaymentValue = this.changeReadPaymentValue.bind(this);
    this.changeHandle = this.changeHandle.bind(this);
    this.blurHandle = this.blurHandle.bind(this);
    this.goToNext = this.goToNext.bind(this);
  }
  componentWillMount() {
    const ID = getUrlQeury().ID;
    const queryFirstName = getUrlQeury().firstName;
    const queryLastName = getUrlQeury().lastName;
    if (!ID) {
      return this.props.gotoRoot();
    }
    this.setState({
      ID: ID,
      queryFirstName: queryFirstName,
      queryLastName: queryLastName
    });
    return this.getPageInfo(ID);
  }

  render() {
    return (
      <div className={cs(appCss.widewrap, 'qa-content')}>
        <div className={cs(appCss.wideStretchable, CreateAccountCss.wrap)}>
          <div className={CreateAccountCss.paymentContent}>
            {
              this.renderContent()
            }
          </div>
        </div>
      </div>
    );
  }
  renderContent() {
    const {paymentOrderInfo, createOrderInfo} = this.props.customerServicePaymentProcess;
    const orderInfo = paymentOrderInfo.data ? paymentOrderInfo.data : {};
    const createOrderError = createOrderInfo.error;
    const createOrderLoading = createOrderInfo.loading;
    const userFirstName = orderInfo.firstName || this.state.queryFirstName;
    const userLastName = orderInfo.lastName || this.state.queryLastName;

    if (paymentOrderInfo.error) {
      return (
        <div className={cs(CreateAccountCss.viewH)} >
          <p
            className={CreateAccountCss.txtCenter}
            onClick={() => this.getPageInfo(this.state.emial)}
          >{paymentOrderInfo.error}</p>
        </div>
      );
    }

    if (!isEmpty(orderInfo)) {
      const plan = orderInfo.billingPlan.grade_name;
      const cycle = orderInfo.billingPlan.bill_cycle
      return (
        <div className={css.wrap}>
          <div className={css.header}>
            <div className={css.tit}>Dear {`${userFirstName} ${userLastName}`}</div>
            <p className={css.p}>Thank you for choosing us. Please take a moment to finish your order.</p>
          </div>
          <div className={css.body}>
            <div className={cs(css.tit, css.summary)}>Order Summary</div>
            <div className={css.fill}>Total to be charged for first time</div>
            <div className={css.partSummary}>
              <ul className={css.productWrap}>
                <li className={css.thWrap}>
                  <div>Product</div>
                  <div>Price</div>
                </li>
                <li className={css.tdWrap}>
                  <div className={css.opacity4}>
                    <span className={css.capitalize}>{plan}</span>{' '}
                    - Billed {cycle} </div>
                  <div>${centTo$(orderInfo.billingPlan.discount_price)}</div>
                </li>
                <li className={css.tdWrap}>
                  <div className={css.opacity4}>Users <span> x </span>{orderInfo.user}</div>
                  <div>{' '}</div>
                </li>
                <li className={cs(css.thWrap, css.marginTop10)}>
                  <div>First Time Total Payment</div>
                  <div className={css.redColor}>
                    ${centTo$(Number(orderInfo.user) * orderInfo.billingPlan.discount_price)}
                  </div>
                </li>
              </ul>
              <p className={cs(css.p, css.removeMg, css.justify, css.marginTop5)}>
                (Your payment will start once your payment is received)<br/>
              </p>
            </div>
            <div className={css.termsWrap}>
              <div className={cs(css.tit, css.summary)}>Purchase Terms</div>
              <div className={css.termsContainer}>
                <PerchaseTerms />
              </div>
              <div className={cs(sharedCss.check, css.check)}>
                <div
                  className={cs(css.checkBox, this.state.haveReadPerchaseTerms && css.checkedBorder)}
                  onClick={this.changeReadPerchaseValue}
                >
                  <span className={this.state.haveReadPerchaseTerms && css.chckedStyle} />
                </div>
                <p className={sharedCss.opacity}>I have read and accept the Purchase Terms.</p>
                {this.state.readPerchaseError
                  && <span className={sharedCss.errorTips}>{this.state.readPerchaseError}</span>
                }
              </div>
            </div>
            <div className={css.payInfo}>
              <div className={css.payBank}>
                <div>
                  <div className={cs(css.tit)}>Payment Info</div>
                  <p className={cs(css.removeMg, css.pd)}>Pay with your credit card via Stripe.</p>
                </div>
                <img src='/assets/Bank_icon.png' className={css.bankIcon}/>
              </div>
              <div className={cs(sharedCss.check, css.check)}>
                <div
                  className={cs(css.checkBox, this.state.haveReadPaymentInfo && css.checkedBorder)}
                  onClick={this.changeReadPaymentValue}
                >
                  <span className={this.state.haveReadPaymentInfo && css.chckedStyle} />
                </div>
                <p>
                  <span className={sharedCss.opacity}>I have read and accept</span>{' '}
                  <a target='_blank' href='https://stripe.com/payment-terms/legal'>Stripe Payment Terms</a>
                  .
                </p>
                {this.state.readPaymentError
                  && <span className={sharedCss.errorTips}>{this.state.readPaymentError}</span>
                }
              </div>
            </div>
            <div className={css.signWrap}>
              <div className={cs(css.tit)}>Signature</div>
              <div className={css.inputWrap}>
                <input
                  className={css.signInput}
                  value={this.state.signature}
                  onChange={this.changeHandle}
                  onBlur={this.blurHandle}
                  type='text'
                />
                {this.state.signatureError
                  && (<span className={cs(sharedCss.errorTips, css.bottomPayment)}>{this.state.signatureError}</span>)
                }
              </div>
              <p className={cs(sharedCss.opacity, css.removeMg, css.justify)}>
                By typing your name in the signature box you agree that you are
                (or by typing your name in the signature box on behalf of a legal entity,
                you agree that such entity is) legally bound by Terms and Conditions,
                pricing information and other provisions above.
              </p>
            </div>
            <div className={cs(sharedCss.btnWrap, CreateAccountCss.btnWrapLimitHeights)}>
              {this.state.signature
                && this.state.haveReadPerchaseTerms
                && this.state.haveReadPaymentInfo
                ? (<Button
                  className={cs(sharedCss.marginLef, sharedCss.wide, css.loadingWrap)}
                  mods={['large', 'action']}
                  onClick={this.goToNext}
                >{this.renderBtnContent(createOrderLoading)}</Button>)
                : (<Button
                  className={cs(sharedCss.marginLef, sharedCss.wide)}
                  mods={['large']}
                  onClick={this.goToNext}
                >Next</Button>)
              }
              {createOrderError
                && <span className={cs(sharedCss.errorTips, css.bottomPayment, css.left50)}>{createOrderError}</span>
              }
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={CreateAccountCss.viewH}>
        <div className={cs(CreateAccountCss.spinnerLine, CreateAccountCss.pdtop)}>
          <div className={cs(CreateAccountCss.spinner, CreateAccountCss.marginCenter)}>
            <Spinner scalable={true}/>
          </div>
        </div>
      </div>
    );
  }

  renderBtnContent(loading) {
    if (loading) {
      return (
        <LoadingSpiner />
      );
    }
    return 'Next';
  }

  goToNext() {
    this.judgeEmpty();
    const val = this.props.customerServicePaymentProcess.paymentOrderInfo.data;
    const requestData = Object.assign({}, val, {
      ID: this.state.ID,
      firstName: this.state.queryFirstName,
      lastName: this.state.queryLastName,
    })

    if (this.state.haveReadPerchaseTerms && this.state.haveReadPaymentInfo && !this.state.signatureError) {
      store.dispatch((dispatch, getState) => createOrderActions(dispatch, getState, requestData));
    }
  }

  judgeEmpty() {
    let signatureError;

    if (this.state.signature && this.state.signatureError) {
      signatureError = this.state.signatureError;
    } else if (this.state.signature && !this.state.signatureError) {
      signatureError = '';
    } else {
      signatureError = errorInfoConfig.signText.empty;
    }

    return this.setState({
      readPaymentError: this.state.haveReadPaymentInfo ? '' : errorInfoConfig.readTerms.empty,
      readPerchaseError: this.state.haveReadPerchaseTerms ? '' : errorInfoConfig.readTerms.empty,
      signatureError: signatureError,
    });
  }

  blurHandle(e) {
    let error = '';
    const {firstName, lastName} = this.props.customerServicePaymentProcess.paymentOrderInfo.data;
    const userFirstName = trim(firstName) || trim(this.state.queryFirstName);
    const userLastName = trim(lastName) || trim(this.state.queryLastName);
    const userName = `${userFirstName} ${userLastName}`;
    const inputValue = trim(e.target.value);
    if (inputValue) {
      if (inputValue !== userName) {
        error = errorInfoConfig.signText.wrong;
      }
    } else {
      error = errorInfoConfig.signText.empty;
    }
    return this.setState({
      signature: inputValue,
      signatureError: error,
    });
  }
  changeHandle(e) {
    return this.setState({
      signature: e.target.value,
      signatureError: '',
    });
  }

  changeReadValue(type, error) {
    return this.setState({
      [type]: !this.state[type],
      [error]: this.state[type] ? errorInfoConfig.readTerms.empty : '',
    });
  }

  changeReadPerchaseValue() {
    return this.changeReadValue('haveReadPerchaseTerms', 'readPerchaseError');
  }

  changeReadPaymentValue() {
    return this.changeReadValue('haveReadPaymentInfo', 'readPaymentError');
  }

  getPageInfo(param) {
    let ID;
    if (param) {
      ID = param;
    } else {
      ID = this.state.ID;
    }
    store.dispatch((dispatch, getState) => getDirectOrderInfo(dispatch, getState, ID));
  }
}

export default connect(({customerServicePaymentProcess}) => (
  {customerServicePaymentProcess}
), mapDispatch({
  gotoRoot: () => changeURL('/'),
}))(CreatePayment);



// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/CreatePayment/index.js